module.exports = {"es-PY":{"components":{"lot-group-item-overlay":{"title":"Detalles del ítem"}}}}